'use strict';

angular.module('far.admin')
    .controller('DocumentEditController', function ($rootScope, $log, form, FileUploader, fileUploadFilters, showModalMessage, Document, Committee, Discipline, softdeleteable, $window) {
        softdeleteable.setModel(Document);

        var vm = {
            form: form('documentForm'),
            model: {},
            init: function (document) {
                if (document) {
                    vm.model = Document.get(document, function () {
                        var disciplinesWatch = $rootScope.$watch(function () {
                            return Discipline.list.length;
                        }, function (length) {
                            if (length > 3) {
                                var disciplinesLength = vm.model.disciplines.length;

                                if (disciplinesLength) {
                                    Discipline.list.forEach(function (value) {
                                        if (length == disciplinesLength) {
                                            value.selected = true;
                                        } else {
                                            vm.model.disciplines.forEach(function (selected) {
                                                if (value.id == selected.id) {
                                                    value.selected = true;
                                                }
                                            });
                                        }
                                    });
                                }

                                disciplinesWatch();
                            }
                        });

                        var typesWatch = $rootScope.$watch(function () {
                            return Document.types.length;
                        }, function (length) {
                            if (length > 3) {
                                var typesLength = vm.model.types.length;

                                if (typesLength) {
                                    Document.types.forEach(function (value) {
                                        if (length == typesLength) {
                                            value.selected = true;
                                        } else {
                                            vm.model.types.forEach(function (selected) {
                                                if (value.id == selected.id) {
                                                    value.selected = true;
                                                }
                                            });
                                        }
                                    });
                                }

                                typesWatch();
                            }
                        });

                        var kindsWatch = $rootScope.$watch(function () {
                            return Document.kinds.length;
                        }, function (length) {
                            if (length > 3) {
                                var kindsLength = vm.model.kinds.length;

                                if (kindsLength) {
                                    Document.kinds.forEach(function (value) {
                                        if (length == kindsLength) {
                                            value.selected = true;
                                        } else {
                                            vm.model.kinds.forEach(function (selected) {
                                                if (value.id == selected.id) {
                                                    value.selected = true;
                                                }
                                            });
                                        }
                                    });
                                }

                                kindsWatch();
                            }
                        });

                        var committeesWatch = $rootScope.$watch(function () {
                            return Document.committees.length;
                        }, function (length) {
                            if (length > 3) {
                                var committeesLength = vm.model.committees.length;

                                if (committeesLength) {
                                    Document.committees.forEach(function (value) {
                                        if (length == committeesLength) {
                                            value.selected = true;
                                        } else {
                                            vm.model.committees.forEach(function (selected) {
                                                if (value.id == selected.id) {
                                                    value.selected = true;
                                                }
                                            });
                                        }
                                    });
                                }

                                committeesWatch();
                            }
                        });

                        var new_committeesWatch = $rootScope.$watch(function () {
                            return Document.new_committees.length;
                        }, function (length) {
                            if (length > 1) {
                                var new_committeesLength = vm.model.new_committees.length;
                                if (new_committeesLength) {
                                    Document.new_committees.forEach(function (value) {
                                        if (length == new_committeesLength) {
                                            value.selected = true;
                                        } else {
                                            vm.model.new_committees.forEach(function (selected) {
                                                if (value.id == selected.id) {
                                                    value.selected = true;
                                                }
                                            });
                                        }
                                    });
                                }

                                new_committeesWatch();
                            }
                        });

                        if (vm.model.file) {
                            var newFile = new FileUploader.FileItem(vm.form.$fields.file.uploader, {
                                lastModifiedDate: new Date(),
                                size: 1e6,
                                name: vm.model.file.filename
                            });

                            newFile.progress = 100;
                            newFile.isUploaded = true;
                            newFile.isSuccess = true;
                            newFile.serverData = angular.merge({}, vm.model.file);
                            
                            vm.form.$fields.file.uploader.queue.push(newFile);
                        }
                    });
                } else {
                    vm.model = Document.new();
                }
            },
            submit: function () {
                vm.model.save()
                    .then(function (response) {
                        $window.location = Routing.generate('admin_documents');
                    })
                    .catch(function (response) {
                        $log.error(response);

                        if (((((response.data || {}).errors || {}).children || {}).file || {}).errors) {
                            showModalMessage('Не загружен файл');
                        } else {
                            showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
                        }
                    });
            },
            isDelete: function(id) {
                return softdeleteable.check(id);
            },
            delete: function(id) {
                if (confirm("Вы уверены?")) {
                    softdeleteable.delete(id, function() {
                        $window.location = Routing.generate('admin_documents')
                    });
                }
            },
            restore: function(id) {
                softdeleteable.restore(id);
            }
        };

        vm.form
            .addField('disciplines', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Discipline.list)
            .addField('types', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Document.types)
            .addField('kinds', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Document.kinds)
            .addField('committees', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Document.committees)
            .addField('new_committees', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Document.new_committees)
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название документа'
                },
                label: 'Название документа'
            })
            .addField('year', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Год'
                },
                label: 'Год'
            })
            .addField('top', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Показывать в меню'
                },
                label: 'Топ'
            })
            .addField('rank', 'text', {
                validators: {
                    required: false,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Позиция'
                },
                label: 'Позиция в топ'
            })
            .addField('file', 'fileUpload', {
                validators: {
                    required: true
                },
                label: 'Файл',
                uploader: {
                    url: Routing.generate('api_upload_post_file'),
                    autoUpload: true,
                    filters: [
                        fileUploadFilters.fileSize(),
                        fileUploadFilters.fileType()
                    ],
                    onSuccessItem: function (item, response) {
                        item.serverData = response;

                        vm.model.file = response;
                    },
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            })
        ;

        return vm;
    });
